// @ts-nocheck
import styled, { css } from 'styled-components';
import type { ContainerType } from 'flow/store/engine/types';
import type { EdgeState } from 'flow/service/graph';
import {
  DEFAULT_EDGE_COLOR,
  EDGE_STROKE_WIDTH,
  FOCUSED_EDGE_COLOR_BY_CONTAINER_TYPE,
} from './constants';


type StyledBaseEdgeProps = {
  edgeState: EdgeState;
  containerType: ContainerType | null;
};


const normalStyles = css`
  opacity: 1;
  stroke: var(--cl-gray-500);
`;

const fadedStyles = css`
  stroke: var(--cl-gray-100);
`;

const deemphasizedStyles = css`
  stroke: var(--cl-gray-300);
`;

/**
 * for now, we're handling hiding edges via its state and through CSS instead of
 * setting the `hidden` prop of the `Edge` object to true. changing the data
 * object would require running the logic to rebuild and layout and this could
 * be heavy on the UI thread. if the overhead of rendering hidden edges becomes
 * a problem, look into hiding edges at the data level
 */
const hiddenStyles = css`
  opacity: 0;
`;


export const StyledBaseEdge = styled.path`
&&& {
  stroke-width: ${EDGE_STROKE_WIDTH}px;
  transition: opacity 150ms ease;

  /* Styles based on Edge state */
  ${({ edgeState, containerType }: StyledBaseEdgeProps) => {
    if (edgeState === 'normal') return normalStyles;
    if (edgeState === 'focused') {
      return css`
          stroke: ${FOCUSED_EDGE_COLOR_BY_CONTAINER_TYPE[containerType]
          ?? DEFAULT_EDGE_COLOR};
        `;
    }
    if (edgeState === 'faded') return fadedStyles;
    if (edgeState === 'deemphasized') return deemphasizedStyles;
    if (edgeState === 'hidden') return hiddenStyles;
    return null;
  }}
}
`;
